import type { CatalogueRef, ProviderEmailConfig, ProviderEmailPreview, CatalogueReviewProof } from '../../api/emailCatalogue';

export const isProviderEmail = <T,>(value: T): value is T & ProviderEmailConfig =>
  !!value && typeof value === 'object' && (value as { delivery_mode?: unknown }).delivery_mode === 'provider_template_v1';
export const sameRef = (left: CatalogueRef | undefined, right: CatalogueRef | undefined): boolean => !!left && !!right
  && left.option_id === right.option_id && left.revision === right.revision && left.config_hash === right.config_hash;
export const reviewProof = (preview: ProviderEmailPreview): CatalogueReviewProof | null =>
  preview.status === 'ready' && !preview.blockers.length && preview.settings.provider ? {
    catalogue_ref: preview.catalogue_ref, provider_fingerprint: preview.settings.provider.evidence.fingerprint,
    review_hash: preview.review_hash,
  } : null;
export const proofMatches = (preview: ProviderEmailPreview, proof?: CatalogueReviewProof): boolean => {
  const expected = reviewProof(preview);
  return !!expected && !!proof && sameRef(expected.catalogue_ref, proof.catalogue_ref)
    && expected.provider_fingerprint === proof.provider_fingerprint && expected.review_hash === proof.review_hash;
};
